formatBillingPeriod